import config from '../types/config';

const setMenuOpen = (bool) => ({
  type: config.SET_MENU_OPEN,
  bool,
});

const setFormTopic = (string) => ({
  type: config.SET_FORM_TOPIC,
  string,
});
const setFormTopicError = (string) => ({
  type: config.SET_FORM_TOPIC_ERROR,
  string,
});

const setFormPolicyError = (string) => ({
  type: config.SET_FORM_POLICY_ERROR,
  string,
});
const setFormPolicy = (string) => ({
  type: config.SET_FORM_POLICY,
  string,
});

const setFormName = (string) => ({
  type: config.SET_FORM_NAME,
  string,
});
const setFormNameError = (string) => ({
  type: config.SET_FORM_NAME_ERROR,
  string,
});

const setFormAgencyName = (string) => ({
  type: config.SET_FORM_AGENCY_NAME,
  string,
});
const setFormAgencyNameError = (string) => ({
  type: config.SET_FORM_AGENCY_NAME_ERROR,
  string,
});

const setFormEmail = (string) => ({
  type: config.SET_FORM_EMAIL,
  string,
});
const setFormEmailError = (string) => ({
  type: config.SET_FORM_EMAIL_ERROR,
  string,
});

const setFormPhone = (string) => ({
  type: config.SET_FORM_PHONE,
  string,
});
const setFormPhoneError = (string) => ({
  type: config.SET_FORM_PHONE_ERROR,
  string,
});

const setFormMessage = (string) => ({
  type: config.SET_FORM_MESSAGE,
  string,
});
const setFormMessageError = (string) => ({
  type: config.SET_FORM_MESSAGE_ERROR,
  string,
});

const setFormCity = (string) => ({
  type: config.SET_FORM_CITY,
  string,
});
const setFormCityError = (string) => ({
  type: config.SET_FORM_CITY_ERROR,
  string,
});

const setFormStreet = (string) => ({
  type: config.SET_FORM_STREET,
  string,
});
const setFormStreetError = (string) => ({
  type: config.SET_FORM_STREET_ERROR,
  string,
});

const setFormZip = (string) => ({
  type: config.SET_FORM_ZIP,
  string,
});
const setFormZipError = (string) => ({
  type: config.SET_FORM_ZIP_ERROR,
  string,
});

const setModalSuccessOpen = (boolean) => ({
  type: config.SET_MODAL_SUCCESS_OPEN,
  boolean,
});

const setLoading = (boolean) => ({
  type: config.SET_LOADING,
  boolean,
});

const setContactUsLoading = (boolean) => ({
  type: config.SET_CONTACT_US_LOADING,
  boolean,
});

const setContactAgentLoading = (boolean) => ({
  type: config.SET_CONTACT_AGENT_LOADING,
  boolean,
});

const setBecomeAgentLoading = (boolean) => ({
  type: config.SET_BECOME_AGENT_LOADING,
  boolean,
});

const setApplyLoading = (boolean) => ({
  type: config.SET_APPLY_LOADING,
  boolean,
});

// isContactUsLoading: false,
//     isContactAgentLoading: false,
//     isBecomeAgentLoading: false,
//     isApplyFormLoading: false
// const SET_CONTACT_US_FORM_LOADING = 'SET_CONTACT_US_FORM_LOADING'
// const SET_CONTACT_AGENT_FORM_LOADING = 'SET_CONTACT_AGENT_FORM_LOADING'
// const SET_BECOME_AGENT_FORM_LOADING = 'SET_BECOME_AGENT_FORM_LOADING'
// const SET_APPLY_FORM_LOADING = 'SET_APPLY_FORM_LOADING'


export default {
  setMenuOpen,
  setFormTopic,
  setFormTopicError,
  setFormPolicy,
  setFormPolicyError,
  setFormName,
  setFormNameError,
  setFormAgencyName,
  setFormAgencyNameError,
  setFormEmail,
  setFormEmailError,
  setFormPhone,
  setFormPhoneError,
  setFormMessage,
  setFormMessageError,
  setFormCity,
  setFormCityError,
  setFormStreet,
  setFormStreetError,
  setFormZip,
  setFormZipError,
  setModalSuccessOpen,
  setLoading,
  setContactUsLoading,
  setContactAgentLoading,
  setBecomeAgentLoading,
  setApplyLoading
};
